let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b6xhe")).then(() => parcelRequire('9j532'));